import enCollapse from "./en";
import frCollapse from "./fr";
import deCollapse from "./de";

export { enCollapse, frCollapse, deCollapse };
